export const appURL = process.env.REACT_APP_URL ?? '';
export const spAppURL = process.env.REACT_APP_SP_APP_URL ?? '';
export const apiURL = process.env.REACT_APP_API_URL ?? '';
export const apiKey = process.env.REACT_APP_API_KEY ?? '';

export const serviceName = process.env.REACT_APP_MINKABU_SERVICE_NAME ?? '';
export const loginURL = process.env.REACT_APP_MINKABU_LOGIN_URL ?? '';
export const registerURL = process.env.REACT_APP_MINKABU_REGISTER_URL ?? '';
export const logoutURL = process.env.REACT_APP_MINKABU_LOGOUT_URL ?? '';
export const accountSettingURL =
  process.env.REACT_APP_MINKABU_ACCOUNT_SETTING_URL ?? '';
export const paymentProfilesURL =
  process.env.REACT_APP_MINKABU_PAYMENT_PROFILES_URL ?? '';

export const premiumLogoURL = process.env.REACT_APP_MINKABU_PREMIUM_LOGO_URL;
export const premiumURL = process.env.REACT_APP_MINKABU_PREMIUM_URL ?? '';
export const premiumLpURL = process.env.REACT_APP_MINKABU_PREMIUM_LP_URL ?? '';
export const myPageURL = process.env.REACT_APP_MINKABU_MYPAGE_URL ?? '';
export const myPageSpURL = process.env.REACT_APP_MINKABU_MYPAGE_SP_URL ?? '';
export const investmentTrustFundFavoritesURL =
  process.env.REACT_APP_MINKABU_ITF_COLLECT_URL ?? '';
export const stockURL = process.env.REACT_APP_MINKABU_STOCK_URL ?? '';
export const usStockURL = process.env.REACT_APP_MINKABU_US_STOCK_URL ?? '';
export const foreignExchangeURL = process.env.REACT_APP_MINKABU_FX_URL ?? '';
export const cryptocurrencyURL = process.env.REACT_APP_MINKABU_CC_URL ?? '';
export const futuresURL = process.env.REACT_APP_MINKABU_FU_URL ?? '';
export const investmentTrustFundURL =
  process.env.REACT_APP_MINKABU_ITF_URL ?? '';
export const magURL = process.env.REACT_APP_MINKABU_MAG_URL ?? '';
export const insuranceURL = process.env.REACT_APP_MINKABU_INS_URL ?? '';

export const beginnerURL = process.env.REACT_APP_MINKABU_BEGINNER_URL ?? '';
export const investmentTrustFundBeginnerURL =
  process.env.REACT_APP_MINKABU_ITF_LEARNING_URL ?? '';
export const foreignExchangeBeginnerURL =
  process.env.REACT_APP_MINKABU_FX_BEGINNER_URL ?? '';
export const cryptocurrencyBeginnerURL =
  process.env.REACT_APP_MINKABU_CC_BEGINNER_URL ?? '';
export const reitBeginnerURL =
  process.env.REACT_APP_MINKABU_RE_BEGINNER_URL ?? '';
export const futuresBeginnerURL =
  process.env.REACT_APP_MINKABU_FU_BEGINNER_URL ?? '';
export const insuranceBeginnerURL =
  process.env.REACT_APP_MINKABU_INS_BEGINNER_URL ?? '';
export const securityCompanyCompareURL =
  process.env.REACT_APP_MINKABU_HIKAKU_URL ?? '';
export const foreignExchangeCompareURL =
  process.env.REACT_APP_MINKABU_FX_HIKAKU_URL ?? '';
export const cryptocurrencyCompareURL =
  process.env.REACT_APP_MINKABU_CC_HIKAKU_URL ?? '';

export const companyURL = process.env.REACT_APP_MINKABU_COMP_URL ?? '';
export const termsOfServiceURL =
  process.env.REACT_APP_MINKABU_TERMS_OF_SERVICE_URL ?? '';
export const privacyPolicyURL =
  process.env.REACT_APP_MINKABU_PRIVACY_POLICY_URL ?? '';
export const trusteURL = process.env.REACT_APP_MINKABU_TRUSTE_URL ?? '';
export const economyURL = process.env.REACT_APP_MINKABU_ECONOMY_URL ?? '';
export const lawURL = process.env.REACT_APP_MINKABU_LAW_URL ?? '';
export const advertisingURL =
  process.env.REACT_APP_MINKABU_ADVERTISING_URL ?? '';
export const helpURL = process.env.REACT_APP_MINKABU_HELP_URL ?? '';
// export const inquieryURL = process.env.REACT_APP_MINKABU_INQUIERY_URL ?? '';
export const questionnaireURL =
  process.env.REACT_APP_MINKABU_QUESTIOMMAIRE ?? '';

export const minkabuStockInfoBaseURL =
  process.env.REACT_APP_MINKABU_STOCK_INFO_BASE_URL ?? '';
export const minkabuInvestmentTrustFundInfoBaseURL =
  process.env.REACT_APP_MINKABU_ITF_INFO_BASE_URL ?? '';

export const TECOTECH_ACCOUNT_URL =
  process.env.REACT_APP_TECOTECH_ACCOUNT_URL ?? '';
export const TECOTECH_ACCESS_TOKEN =
  process.env.REACT_APP_TECOTECH_ACCESS_TOKEN ?? '';
export const monoAccountURL = process.env.REACT_APP_MONO_ACCOUNT_URL ?? '';
export const monoAccountRegisterURL =
  process.env.REACT_APP_MONO_ACCOUNT_REGISTER_URL ?? '';

export const moneytreeBaseURL = process.env.REACT_APP_MONEYTREE_BASE_URL ?? '';
export const moneytreeManagementURL =
  process.env.REACT_APP_MONEYTREE_MANAGEMENT_URL ?? '';
export const moneytreeClientId =
  process.env.REACT_APP_MONEYTREE_CLIENT_ID ?? '';

export const lineAddFriendURL = process.env.REACT_APP_LINE_ADD_FRIEND_URL ?? '';

export const webPushPublickKey =
  process.env.REACT_APP_WEB_PUSH_PUBLICK_KEY ?? '';
export const webPushPrivateKey =
  process.env.REACT_APP_WEB_PUSH_PRIVATE_KEY ?? '';

export const TEST_REAL_DATA_SESSIONID =
  process.env.REACT_APP_TEST_REAL_DATA_SESSIONID ?? '';
